import React, { useState, useEffect } from 'react';

const GlobalAnalytics = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/chairman/overview', {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
    })
      .then(r => r.json())
      .then(d => { setData(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return <div style={{padding:'20px',color:'#94a3b8'}}>Loading global analytics...</div>;

  return (
    <div style={{padding:'20px'}}>
      <h2 style={{color:'#7c3aed',marginBottom:'4px'}}>🌐 Global Analytics</h2>
      <p style={{color:'#64748b',marginBottom:'24px',fontSize:'13px'}}>Aggregated across all tenants</p>

      <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'16px',marginBottom:'24px'}}>
        <div style={{background:'#1e293b',borderRadius:'12px',padding:'20px',border:'1px solid #334155'}}>
          <div style={{color:'#64748b',fontSize:'12px',marginBottom:'8px'}}>TOTAL TENANTS</div>
          <div style={{color:'#7c3aed',fontSize:'32px',fontWeight:'bold'}}>{data?.totalTenants || 0}</div>
        </div>
        <div style={{background:'#1e293b',borderRadius:'12px',padding:'20px',border:'1px solid #334155'}}>
          <div style={{color:'#64748b',fontSize:'12px',marginBottom:'8px'}}>TOTAL EMPLOYEES</div>
          <div style={{color:'#34d399',fontSize:'32px',fontWeight:'bold'}}>{data?.totalEmployees || 0}</div>
        </div>
        <div style={{background:'#1e293b',borderRadius:'12px',padding:'20px',border:'1px solid #334155'}}>
          <div style={{color:'#64748b',fontSize:'12px',marginBottom:'8px'}}>TOTAL CLIENTS</div>
          <div style={{color:'#3b82f6',fontSize:'32px',fontWeight:'bold'}}>{data?.totalClients || 0}</div>
        </div>
      </div>

      <h3 style={{color:'#e2e8f0',marginBottom:'16px'}}>Tenant Breakdown</h3>
      {data?.tenants?.map(t => (
        <div key={t.businessId} style={{
          background:'#1e293b',borderRadius:'12px',padding:'16px',
          marginBottom:'12px',border:'1px solid #334155'
        }}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <div>
              <h4 style={{color:'#e2e8f0',margin:0}}>{t.name}</h4>
              <p style={{color:'#64748b',margin:'4px 0',fontSize:'12px'}}>{t.businessId}</p>
            </div>
            <div style={{display:'flex',gap:'24px',textAlign:'center'}}>
              <div>
                <div style={{color:'#34d399',fontSize:'20px',fontWeight:'bold'}}>{t.employees}</div>
                <div style={{color:'#64748b',fontSize:'11px'}}>employees</div>
              </div>
              <div>
                <div style={{color:'#3b82f6',fontSize:'20px',fontWeight:'bold'}}>{t.clients}</div>
                <div style={{color:'#64748b',fontSize:'11px'}}>clients</div>
              </div>
              <div>
                <div style={{color: t.error ? '#f87171' : '#34d399',fontSize:'20px'}}>
                  {t.error ? '❌' : '✅'}
                </div>
                <div style={{color:'#64748b',fontSize:'11px'}}>status</div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default GlobalAnalytics;
